module.exports = __webpack_public_path__ + "img/gps_not_fixed.e8d1e3d8.svg";